var _excluded = ["image", "title", "to", "href", "hrefTitle", "onClick", "openInNewTab"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { cover } from "polished";
import styled, { css } from "styled-components";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import TextAtm from "../../atoms/TextAtm";
import Link from "../../quarks/Link";
var Container = styled.div.withConfig({
  componentId: "sc-1k39mho-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["", ";display:flex;position:relative;flex-direction:column;align-items:center;padding:", ";border-radius:", ";&:hover{background:", ";box-shadow:", ";}"], transition("background", "box-shadow"), space(3), getBorderRadius(theme, "small"), getColor(theme, "backgroundLight"), getBoxShadow(theme, "small"));
});
var Title = styled(TextAtm).withConfig({
  componentId: "sc-1k39mho-1"
})(["margin-top:", ";"], space(3));
var StyledLink = styled(Link).withConfig({
  componentId: "sc-1k39mho-2"
})(["color:inherit;text-decoration:none;&::before{", ";content:\"\";}"], cover());
function TitledImageLinkMol(_ref2) {
  var image = _ref2.image,
    title = _ref2.title,
    to = _ref2.to,
    href = _ref2.href,
    hrefTitle = _ref2.hrefTitle,
    onClick = _ref2.onClick,
    openInNewTab = _ref2.openInNewTab,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Container, restProps, image, /*#__PURE__*/React.createElement(Title, {
    typography: "big4",
    align: "center"
  }, /*#__PURE__*/React.createElement(StyledLink, {
    to: to,
    href: href,
    title: hrefTitle,
    onClick: onClick,
    openInNewTab: openInNewTab
  }, title)));
}
export default TitledImageLinkMol;